import React, { useState } from "react";
import styles from "./PasswordChangeForm.module.css";
import { EyeIcon, LockIcon } from "../Icons/Icons";
import { useTranslation } from "react-i18next";

export const PasswordRecoverForm = ({
  handlePasswordNew,
  handlePasswordNewConfirm,
  handlePasswordSubmit,
  passwordNew,
  passwordNewConfirm,
}) => {
  const { t } = useTranslation();

  const [isOpenNew, setisOpenNew] = useState(false);
  const openPasswordNew = () => setisOpenNew(!isOpenNew);
  const typeOfInputNew = isOpenNew ? "text" : "password";

  const [isOpenConfirm, setisOpenConfirm] = useState(false);
  const openPasswordConfirm = () => setisOpenConfirm(!isOpenConfirm);
  const typeOfInputConfirm = isOpenConfirm ? "text" : "password";
  return (
    <>
      <form
        className={styles.LoginPasswordFormWrapper}
        onSubmit={handlePasswordSubmit}
      >
        <h3 className={styles.PasswordChangeHeader}>{t("comp.changePass")}</h3>

        <div className={styles.inputWrapper}>
          <LockIcon />
          <input
            className={styles.input}
            onChange={handlePasswordNew}
            placeholder={t("comp.newPass")}
            type={typeOfInputNew}
            value={passwordNew}
          />
          <div onClick={openPasswordNew}>
            <EyeIcon />
          </div>
        </div>
        <div className={styles.inputWrapper}>
          <LockIcon />
          <input
            className={styles.input}
            onChange={handlePasswordNewConfirm}
            placeholder={t("comp.confirmPass")}
            type={typeOfInputConfirm}
            value={passwordNewConfirm}
          />
          <div onClick={openPasswordConfirm}>
            <EyeIcon />
          </div>
        </div>

        <button
          className={styles.submit}
          type="submit"
          onClick={handlePasswordSubmit}
        >
           {t("comp.save")}
        </button>
      </form>
    </>
  );
};
